import React from "react";
import { MDBRipple } from "mdb-react-ui-kit";

const Logo = ({ src }) => (
  <MDBRipple tag="a" className="d-flex justify-content-center py-4 sidebar-logo">
    <img id="MDB-logo" src={src} alt="Property Boss Logo" draggable="false" />
  </MDBRipple>
);

export default Logo;
